<template>
  <v-dialog
    :value="open"
    persistent
    max-width="350"
    content-class="task-item-dialog"
  >
    <v-card color="#f0f0ef" class="home-form-container">
      <v-card-text
        v-if="editedItem !== null"
        class="home-form-container"
        style="text-align: left; padding: 4px 0 0 0"
      >
        <input-field
          :label="$tc('Label')"
          v-model="editedItem.label"
          variable-name="title"
          input-type="text"
          size="100"
          :required="true"
        />
        <input-field
          :label="$tc('Index')"
          v-model="editedItem.index"
          variable-name="title"
          input-type="number"
          size="100"
          :required="true"
        />
        <v-checkbox
            :label="$tc('Required')"
            v-model="editedItem.required"
            color="accent"
            class="mt-1 ml-4"
        />
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <management-button
          type="cancel"
          :label="$t('Cancel')"
          @buttonClick="close"
        />
        <management-button
          type="execute"
          :label="editing ? $t('ApplyChanges') : $t('Add')"
          :disabled="requiredAreFilled"
          @buttonClick="applyChanges"
        />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import InputField from "@/components/Home/Forms/_Molecules/InputField";
import _ from "lodash";
import managementButton from "@/components/Management/ManagementButton";

export default {
  name: "PhotoLabelEditCreateDialog",

  components: { InputField, managementButton },

  props: {
    open: {
      type: Boolean,
      required: true
    },

    originalItem: {
      type: Object,
      required: true
    },
    itemIndex: {
      type: Number
    }
  },

  data() {
    return {
      editedItem:{},

      dependencyOptions: null
    };
  },

  mounted() {
    this.setItemToEdit();
  },

  computed: {
    requiredAreFilled() {
      return (!!this.editedItem.label && !!this.editedItem.index ? false : true);
    },
    editing() {
      return this.itemIndex > -1;
    }
  },

  methods: {
    setItemToEdit() {
      this.editedItem = _.cloneDeep(this.originalItem);
    },

    close() {
      this.$emit("close");
    },

    applyChanges() {
      if (this.itemIndex === -1) {
        // add step type
        const copyWithType = {...this.editedItem, type:"photo"};
        this.$emit("add", copyWithType);
      } else {
        this.$emit("edit", this.editedItem);
      }
      this.close();
      
    }
  },

  watch: {
    originalItem() {
      this.setItemToEdit();
    }
  }
};
</script>

<style>
.task-item-dialog {
  overflow-y: visible;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/Forms/_SpecialTabs/Activities/TaskTypes/Photos/PhotoLabelEditCreateDialog.vue